import { useGetMerchantProfile } from "./queries/useMerchantQueries";

export const GAMING_MERCHANT_SEGMENT = "Gaming";

export function useIsGamingMerchant() {
  const { data: merchantProfile, isLoading } = useGetMerchantProfile();
  return {
    isGamingMerchant: merchantProfile?.merchantSegment === GAMING_MERCHANT_SEGMENT,
    isLoading,
  };
}

export default useIsGamingMerchant;
